export const mainContainerStyles = { padding: '16px 16px 0 16px' };

export const flexContainer = { display: 'flex' };

export const dividerStyles = { marginTop: '15px' };

export const companyImageStyles = {
  marginRight: '14px',
  width: '64px',
  maxHeight: '64px',
};

export const rightContainerStyles = {
  marginLeft: 'auto',
  flex: '0 0 40px',
  textAlign: 'right',
};

export const centerContainerStyles = { wordBreak: 'break-word', flexGrow: 1 };

export const ownerTag = {
  backgroundColor: '#0696D7',
  width: '96px',
  height: '20px',
  borderRadius: '44px',
  fontSize: '12px',
  color: 'white',
  textAlign: 'center',
  marginTop: '3px',
  fontWeight: 600,
};
